<template>
  <div class="wrapper box box_v">
    <page-head title="." :btn-list="btnList" :show-back="false" @handleBtn="handleBtn"></page-head>
    <div class="box_f1 box_v card-box">
      <Card dis-hover :padding="20">
        <i-form ref="formInline" inline label-position="top">
          <row :gutter="80">
            <i-col span="8">
              <FormItem label="企业名称" prop="companyName">
                <Input
                  v-model="companyName"
                  placeholder="请输入企业名称"
                  clearable
                  @on-enter="initRecordList"
                  @on-clear="initRecordList"
                />
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="分局名称" prop="depType">
                <Select v-model="deptId" @on-change="initRecordList">
                  <Option
                    v-for="item in depTypeList"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="审核状态" prop="walkType">
                <Select v-model="checkStatus" clearable @on-change="statusChange">
                  <Option value="2" label="待审核">
                    <span>待审核</span>
                  </Option>
                  <Option value="1" label="审核通过">
                    <span>审核通过</span>
                  </Option>
                  <Option value="0" label="审核未通过">
                    <span>审核未通过</span>
                  </Option>
                </Select>
              </FormItem>
            </i-col>
          </row>
        </i-form>
      </Card>
      <Card dis-hover :padding="20" class="box_f1" style="margin-top: 20px">
        <div class="table-card">
          <Table border :columns="settingColumn" :data="recordList" :loading="isTableLoading"></Table>
          <page
            :total="total"
            @on-change="pageChange"
            class="page"
            :page-size="rows"
            :current="page"
            show-total
          />
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import pageHead from "../../components/head";

export default {
  name: "marketChart",
  components: {
    pageHead
  },
  data() {
    return {
      btnList: [
        {
          name: "搜索",
          type: "search",
          loading: false
        },
        {
          name: "重置",
          type: "init",
          loading: false
        },
        {
          name: "导出",
          type: "export",
          loading: false
        }
      ],
      companyName: "",
      checkStatus: "",
      deptId: "",
      depTypeList: [], //所在分局
      walkType: "",
      recordList: [],
      isTableLoading: false,
      settingColumn: [
        {
          title: "工作单位所在乡、街",
          width: 180,
          key: "communityName"
        },
        {
          title: "企业名称",
          key: "companyName",
          width: 180
        },
        {
          title: "分局名称",
          key: "deptName",
          width: 180
        },
        {
          title: "审核状态",
          key: "checkStatus",
          width: 180
        },
        {
          title: "人员名称",
          key: "userName",
          width: 180
        },
        {
          title: "性别",
          key: "sex",
          width: 180
        },
        {
          title: "身份证号",
          key: "idCardNO",
          width: 180
        },
        {
          title: "手机号码",
          key: "phoneNO",
          width: 180
        },
        {
          title: "工作单位行业类别",
          key: "tradeName",
          width: 180
        },
        {
          title: "复工复业时间",
          key: "returnWorkTime",
          width: 180
        },
        {
          title: "复工复业前居住地",
          key: "place4BeforeReturnWork",
          width: 180
        },
        {
          title: "复工复业前15日内是否去过外地",
          key: "leaveHere",
          width: 180
        },
        {
          title: "复工复业前15日内去过何地",
          key: "footprint",
          width: 180
        },
        {
          title: "近期是否发热",
          key: "fever",
          width: 180
        },
        {
          title: "发热人员处置方式",
          key: "handleType",
          width: 180
        },
        {
          title: "1月25日以来是否与涉疫人员接触",
          key: "contact4Epidemic",
          width: 180
        },
        {
          title: "1月25日以来是否与涉武汉人员接触",
          key: "contact4WuHan",
          width: 180
        },
        {
          title: "是否为当日新增从业人员",
          key: "isAddToday",
          width: 180
        },
        {
          title: "备注",
          key: "remark",
          width: 180
        }
      ],
      page: 1,
      rows: 6,
      total: 0
    };
  },
  methods: {
    getRecordList() {
      this.isTableLoading = true;
      this.$get(this.urlobj.people4list, {
        pageNum: this.page,
        pageSize: this.rows,
        deptId: this.deptId,
        checkStatus: this.checkStatus,
        companyName: this.companyName
      }).then(res => {
        // console.log(res.rows);
        this.isTableLoading = false;
        this.recordList = res.rows;
        this.total = res.total;
      });
    },
    handleBtn(type) {
      if (type == "export") {
        this.export();
      } else if (type == "search") {
        this.initRecordList();
      } else if (type == "init") {
        this.deptId = "";
        this.checkStatus = "";
        this.companyName = "";
        this.initRecordList();
      }
    },
    export() {
      let url =
        this.urlobj.people4export +
        "?token=" +
        this.$store.state.access_token +
        "&deptId=" +
        this.deptId +
        "&checkStatus=" +
        this.checkStatus +
        "&companyName=" + 
        this.companyName
        ;
      console.log(url);
      window.open(url);
    },
    initRecordList() {
      this.page = 1;
      this.getRecordList();
    },
    pageChange(val) {
      this.page = val;
      this.getRecordList();
    },
    statusChange(value) {
      this.checkStatus = value ? value : "";
      this.getRecordList();
    },
    //获取所在分局
    getDepList() {
      var url = this.urlobj.getDepList;
      this.$post(url, {
      }).then(res => {
        // console.log(res.rows);
        this.depTypeList = res.rows.map(item => {
          return {
            id: item.id,
            name: item.deptName
          };
        });
      });
    }
  },
  mounted() {
    this.getDepList();
    this.getRecordList();
  }
};
</script>

<style lang="less" scoped>
/deep/ .ivu-form .ivu-form-item-label {
  font-size: 16px;
}

/deep/ .ivu-form-inline .ivu-form-item {
  display: block;
}

/deep/ .ivu-date-picker {
  display: block;
}

/deep/ .ivu-card-body {
  height: 100%;
}

/deep/ .ivu-table-tip {
  overflow-x: hidden;
}
.wrapper {
  height: 100%;
}
.card-box {
  margin: 0 20px 20px;
}
.table-card {
  padding: 20px 0px 80px;
  position: relative;
  height: 100%;
  text-align: right;
}
.page {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}
/deep/ .header {
  visibility: hidden;
}
</style>
